import React from 'react';
import { formatDecimals, formatNumber } from '../../../utils';
import { Flexbox, FlexboxColumn } from '../../action/Flexbox';
import ThemedText from '../../theme/ThemedText';
import './SupertakeTile.scss';

const SupetakeTile = ({ data }) => {
  return (
    <FlexboxColumn gap='0' className='supertaketile_wrapper'>
      <Flexbox className='supertaketile_wrapper_content' fw gap='1.25rem'>
        <Flexbox gap='0.25rem'>
          <ThemedText.H6 color='color-supertake-text' weight={'semi-bold'}>
            ${formatNumber(formatDecimals(data?.airdropDollar))}
          </ThemedText.H6>
          <ThemedText.H6 color='color-supertake-text'>Airdrop</ThemedText.H6>
        </Flexbox>
        <Flexbox gap='0.25rem'>
          <ThemedText.H6 color='color-supertake-text' weight={'semi-bold'}>
            ${formatNumber(formatDecimals(data?.kaitoStaked))}
          </ThemedText.H6>
          <ThemedText.H6 color='color-supertake-text'>Staked</ThemedText.H6>
        </Flexbox>
        {Boolean(Number(data?.genesisNftCount)) && (
          <Flexbox gap='0.25rem'>
            <ThemedText.H6 color='color-supertake-text' weight={'semi-bold'}>
              Kaito Gensis
            </ThemedText.H6>
            <ThemedText.H6 color='color-supertake-text'>NFT Holder</ThemedText.H6>
          </Flexbox>
        )}
      </Flexbox>
    </FlexboxColumn>
  );
};

export default SupetakeTile;
